import { Routes } from '@angular/router';
import { NotLoggedLayoutComponent } from './shared/layouts/not-logged-layout/not-logged-layout.component';
import { CandidatLayoutComponent } from './shared/layouts/candidat-layout/candidat-layout.component';
import { EtablissementLayoutComponent } from './shared/layouts/etablissement-layout/etablissement-layout.component';
import { authGuard } from './core/guard/auth.guard';
import {loggedGuard} from "./core/guard/logged.guard";
import {candidateGuard} from "./core/guard/candidat.guard";
import {establishmentGuard} from "./core/guard/establishment.guard";
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { OnSignEventComponent } from './pages/candidat/on-sign-event/on-sign-event.component';
// Lot F (client clinique) : PAS DE CONTRAT DE MISE À DISPOSITION — route retirée de la navigation (code conservé)
// import { OnDispositionSignEventComponent } from './pages/candidat/on-disposition-sign-event/on-disposition-sign-event.component';
import { AccountActivationPageComponent } from './pages/candidat/account-activation-page/account-activation-page.component';

export const routes: Routes = [
  {
    path: 'on-sign-event',
    component: OnSignEventComponent,
  },
  // Lot F (client clinique) : PAS DE CONTRAT DE MISE À DISPOSITION — route retirée (code conservé)
  // {
  //   path: 'on-disposition-sign-event',
  //   component: OnDispositionSignEventComponent,
  // },
  {
    path: 'account/activate',
    component: AccountActivationPageComponent,
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },

  {
    path: '',
    component: NotLoggedLayoutComponent,
    canActivate: [loggedGuard],
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./core/core.module').then((m) => m.CoreModule),
      },
      {
        path: 'etablissement',
        loadChildren: () =>
          import('./pages/etablissement/etablissement.module').then(
            (m) => m.EtablissementModule
          ),
      },
    ],
  },
  {
    path: '',
    component: CandidatLayoutComponent,
    canActivate: [authGuard, candidateGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/candidat/candidat.module').then(
            (m) => m.CandidatModule
          ),
      },
      // {path : 'candidat' , redirectTo : '/candidat/accueil', pathMatch : 'full' },
    ],
  },
  {
    path: '',
    component: EtablissementLayoutComponent,
    canActivate: [authGuard, establishmentGuard],
    children: [
      {
        path: 'dashboard',
        data: { breadcrumb: { skip: true } },
        loadChildren: () =>
          import('./pages/etablissement/etablissement.module').then(
            (m) => m.EtablissementModule
          ),
      },
    ],
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    title: 'Politique de confidentialité'
  },
  { path: '**', redirectTo: '/home' },
];
